export default __webpack_public_path__ + "static/media/SupportWhats.ce9649ff.png";